// extracted by mini-css-extract-plugin
export default {"grid":"TyreDetails__grid--RxLfq","th":"TyreDetails__th--ME4LU","td":"TyreDetails__td--lv72G"};